export const getPagination = ({ pagination }) => pagination;
export const cnpj_empty = () => ({
  cnpj: "",
  nome: "",
  estados: [],
  municipios: [],
});
